<br>

<div class="container-fluid align-middle">
    <div class="jumbotron text-center" style="color:green">
        We are verifying your identity. Please Wait... <em class="fa fa-spinner fa-pulse fa-3x fa-fw"></em>
    </div>
</div>
<div class="page-container">
</div>